export default function RESETAPP() {
  localStorage.clear();
  window.location.assign('/signin');
}
